<template>
  <div class="sent-email">
    <div class="card rounded-0">
      <accordian-display
        :title="'Email Sent'"
        :icon="'fa fa-share-square'"
        :headerClass="'card-header rounded-0'">
        <div class="card-body rounded-0">
          <p class="small">
            {{ email.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ email.createdAt | date_time_format }}
          </p>
          <p>
            <strong>Subject:</strong>
            {{ email.subject }}
          </p>
          <p>
            <strong>To:</strong>
            {{ email.to }}
          </p>
          <p v-if="email.cc && email.cc.length">
            <strong>CC:</strong>
            <span 
              v-for="(cc, index) in email.cc" 
              :key="index">
              {{ cc }}<span v-if="index !== email.cc.length - 1">, </span>
            </span>
          </p>
          <p v-if="email.bcc && email.bcc.length">
            <strong>BCC:</strong>
            <span 
              v-for="(bcc, index) in email.bcc" 
              :key="index">
              {{ bcc }}<span v-if="index !== email.bcc.length - 1">, </span>
            </span>
          </p>
          <p>
            <strong>Attachments:</strong>
            <span 
              v-for="(attachment, index) in email.Attachments" 
              :key="index">
              <download-input
                :options="{ label: attachment.fileName, permalink: 'downloadFile'}"
                :value="{ objectKey: attachment.objectKey }" />
              <span v-if="index !== email.Attachments.length - 1">, </span>
            </span>
          </p>
        </div>
      </accordian-display>
    </div>
  </div>
</template>

<script>
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'SentEmail',
    props: {
      email: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      AccordianDisplay,
      DownloadInput
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/displays/SentEmail.vue